import * as Yup from "yup";

export const PopupSchema = Yup.object({

    name: Yup.string().required("Enter Popup Name"),
    type: Yup.string().required("Select Type"),
    // link: Yup.string().url('Invalid URL format').required('Link is Required'),
    img:Yup.mixed().required("Select Image"),

});

// export const UpdatePopupSchema = Yup.object({

//     name: Yup.string().required("Enter Banner Name"),
//     type: Yup.string().required("Select Type"),
//     img:Yup.mixed().required("Select Image"),
//     // link: Yup.string().url('Invalid URL format').required('Link is Required'),
//     // banner:Yup.mixed().required("Banner Image"),
// });